import { FunctionComponent, MutableRefObject } from 'react';
import { DraftConfiguration, PrintArea, ProductType } from '@/types';
import { getRestrictions } from '@/utils/embroideryRestrictions';
import { useConfigurationsFrame } from './ConfigurationsFrame';
import { TransformChangedCallback } from './TransformChangedContext';

interface EmbroideryFrameProps {
  configurations: DraftConfiguration[];
  productType: ProductType;
  printArea: PrintArea;
  transformCallbacks: MutableRefObject<Set<TransformChangedCallback>>;
}

export const EmbroideryFrame: FunctionComponent<EmbroideryFrameProps> = ({
  configurations,
  productType,
  printArea,
  transformCallbacks,
}) => {
  const [maxWidth, maxHeight] = getRestrictions(productType, printArea.id);

  return useConfigurationsFrame(configurations, transformCallbacks, { maxWidth, maxHeight });
};
